module.exports = __webpack_public_path__ + "img/favorito.701941ce.svg";